import { createFileRoute } from "@tanstack/react-router";
import CookiePolicy from "@/pages/CookiePolicy";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/cookies")({
  head: () => pageHead("cookies", "es"),
  component: CookiePolicy,
});
